import { render, staticRenderFns } from "./goodDetail.vue?vue&type=template&id=5de7cb36&scoped=true&"
import script from "./goodDetail.vue?vue&type=script&lang=js&"
export * from "./goodDetail.vue?vue&type=script&lang=js&"
import style0 from "./goodDetail.vue?vue&type=style&index=0&id=5de7cb36&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de7cb36",
  null
  
)

export default component.exports